import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";

const scrollToRsvp = () => {
  const el = document.getElementById("rsvp");
  if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
};

export const StickyReserve = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const computeVisibility = () => {
      // Show once user scrolls past ~70% of viewport (past hero)
      const threshold = window.innerHeight * 0.7;
      // Hide once we are inside the RSVP section already
      const rsvpEl = document.getElementById("rsvp");
      const inRsvp = rsvpEl
        ? rsvpEl.getBoundingClientRect().top < window.innerHeight * 0.5
        : false;
      setVisible(window.scrollY > threshold && !inRsvp);
    };
    computeVisibility();
    window.addEventListener("scroll", computeVisibility, { passive: true });
    window.addEventListener("resize", computeVisibility);
    return () => {
      window.removeEventListener("scroll", computeVisibility);
      window.removeEventListener("resize", computeVisibility);
    };
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.button
          type="button"
          onClick={scrollToRsvp}
          data-testid="sticky-reserve-btn"
          initial={{ opacity: 0, y: 12 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 12 }}
          transition={{ duration: 0.35, ease: "easeOut" }}
          className="fixed z-40 right-4 md:right-6 bottom-5 md:top-5 md:bottom-auto inline-flex items-center gap-2.5 px-5 py-3 rounded-full border border-[#D4AF37] bg-[#0a0a0a]/85 backdrop-blur-md text-[#D4AF37] text-[11px] tracking-[0.32em] uppercase hover:bg-[#D4AF37] hover:text-[#0a0a0a] transition-colors duration-300 shadow-[0_8px_30px_rgba(0,0,0,0.6)]"
        >
          <span
            className="w-1.5 h-1.5 rounded-full bg-[#D4AF37] animate-pulse"
            aria-hidden="true"
          />
          Reserve
        </motion.button>
      )}
    </AnimatePresence>
  );
};
